import React from 'react';
import { Button, Slider } from 'antd';
import { PlayCircleFilled, PauseCircleFilled } from '@ant-design/icons';
import PropTypes from 'prop-types';

export const PlaybackControls = ({ isPlaying, onPlaybackChange }) => (
  <Button
    type="link"
    style={{ fontSize: '1.5em' }}
    onClick={() => onPlaybackChange(!isPlaying)}
  >
    {isPlaying ? <PauseCircleFilled /> : <PlayCircleFilled />}
  </Button>
);
PlaybackControls.propTypes={
isPlaying:PropTypes.string,
onPlaybackChange:PropTypes.string,
}
PlaybackControls.defaultProps= {
isPlaying:[],
onPlaybackChange:[],
}
// onScenarioUUIDChange = (e) => {
//     const scenario_uuid = e.target.value;
//     this.setState(() => ({scenario_uuid}));
// }

// onScenarioNameChange = (e) => {
//     const scenario_name = e.target.value;
//     this.setState(() => ({scenario_name}))
// }
export const ProgressBar = (props) => <Slider min={0} {...props} />;
